export default __webpack_public_path__ + "assets/Picture7.jpg";